
import { Component } from "vue-property-decorator";
import Vue from "vue";
import passwordIsValid from "@/utils/patternValidator";
import { showSuccessSnackbar } from "@/utils/snackbarUtils";
import { Emit } from "@/api/apiHelper";

@Component
export default class ChangePassword extends Vue {
  // 📦 The old password that the user is aiming to change
  private oldPassword: string = "";

  // 📦 The new password to which the account should be modified to
  private newPassword: string = "";

  // 📦 The confirmation password that aims to help verifying the validity of the new password
  private confirmNewPassword: string = "";

  // 🚩 Flag for whether the fields should display text/password
  private passwordsVisible = {
    oldPassword: false,
    newPassword: false,
    confirmNewPassword: false,
  };

  // 🚩 Flag for whether the password is being changed on the API
  private isChangingPassword: boolean = false;

  // 👮‍♂️ Validation rules for password field
  private get passwordFieldRules(): (passwordField: string) => any[] {
    return (passwordField: string) => [
      (password: string) => !!password || passwordField + " is required",
      (password: string) =>
        passwordIsValid(password) ||
        "Password should consist of at least 8 characters, at least 1 capital letter and at least 1 number",
    ];
  }

  // 👮‍♂️ Validation rules for confirm new password field
  private confirmPasswordRules = [
    (confirmPassword: string) =>
      !!confirmPassword || "Confirm password is required",
    (confirmPassword: string) =>
      this.arePasswordsTheSame(confirmPassword) || "Passwords should match!",
  ];

  // 🚩 Flag used for determining if the whole form is poperly filled
  private get arePasswordsValid(): boolean {
    return (
      passwordIsValid(this.oldPassword) &&
      passwordIsValid(this.newPassword) &&
      passwordIsValid(this.confirmNewPassword) &&
      this.newPassword == this.confirmNewPassword
    );
  }

  // 🚩 Flag used for dynamically checking whether the 2 passwords are the same
  private arePasswordsTheSame(confirmPassword: string): boolean {
    return confirmPassword === this.newPassword;
  }

  /**
   * 🚀 Saves the changed user password on the API
   */
  private changePassword() {
    this.isChangingPassword = true;
    Vue.prototype.$api
      .post("/api/v1/users/changepassword", {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        confirmation_password: this.confirmNewPassword,
      }, Emit.All, true)
      .then((respone: any) => {
        showSuccessSnackbar("Your password was successfully updated!");
        (this.$refs.changePasswordForm as any).reset();
      })
      .finally(() => (this.isChangingPassword = false));
  }
}
